import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { AppConfiguration } from '../stores/AppConfigurationStore';
import { PersistentStore } from '../stores/PersistentStore';
import { PersistentActions } from '../actions/PersistentActions';

export class SelectionLanguage extends SelectionBase {
    protected id: string = 'language-select';

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: PersistentStore.getState().language,
            visible: true,
            enabled: true
        });
    };

    protected getLabel(): string {
        return t('Language');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {value: 'de', name: t('German'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('de'); }},
            {value: 'en', name: t('English'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('en'); }},
            {value: 'es', name: t('Spanish'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('es'); }},
            {value: 'fr', name: t('French'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('fr'); }},
            {value: 'it', name: t('Italian'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('it'); }},
            {value: 'nl', name: t('Dutch'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('nl'); }},
            {value: 'pl', name: t('Polish'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('pl'); }},
            {value: 'pt', name: t('Portuguese'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('pt'); }},
            {value: 'ro', name: t('Romanian'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('ro'); }},
            {value: 'tr', name: t('Turkish'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('tr'); }},
        ].filter((language) => {
            return (
                AppConfiguration.AllowedLanguages.indexOf(language.value) !== -1
            );
        }).sort((a: SelectBoxOption, b: SelectBoxOption) => {return a.name > b.name ? 1 : -1; });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionLanguage.tsx